const lightPluginCategoriesSidebar = {
  'plugin.categories.color': 'rgba(0,0,0,0.6)',
  'plugin.categories.header.color': 'rgba(0,0,0,0.7)',
};

const darkPluginCategoriesSidebar = {
  'plugin.categories.color': 'rgba(255,255,255,0.6)',
  'plugin.categories.header.color': 'rgba(255,255,255,0.7)',
};

const lightModal = {
  'modal.title.color': 'rgba(0,0,0,0.8)',
  'modal.description.color': 'rgba(0,0,0,0.6)',
  'modal.input.border.color': 'rgba(0,0,0,0.15)',
  'modal.input.bg.color': '#F6F7F8',
  'modal.input.color': 'rgba(0,0,0,0.7)',
  'modal.input.placeholder.color': 'rgba(0,0,0,0.54)',
  'modal.plugin.shadow': '0 6px 6px -3px rgba(0,0,0,0.15), 0 10px 32px 3px rgba(50,50,93,0.1), 0 8px 40px 3px rgba(0,0,0,0.08)',
  'modal.subtitle.color': 'rgba(0,0,0,0.4)',
};

const darkModal = {
  'modal.title.color': 'rgba(255,255,255,0.8)',
  'modal.description.color': 'rgba(255,255,255,0.6)',
  'modal.input.border.color': 'rgba(255,255,255,0.15)',
  'modal.input.bg.color': '#18212D',
  'modal.input.color': 'rgba(255,255,255,0.7)',
  'modal.input.placeholder.color': 'rgba(255,255,255,0.54)',
  'modal.plugin.shadow': '0 6px 12px 0 rgba(0,0,0,0.22), 0 16px 38px 6px rgba(0,0,0,0.18), 0 12px 28px 0 rgba(0,0,0,0.18), 0 16px 80px -30px rgba(0,0,0,0.2)',
  'modal.subtitle.color': 'rgba(255,255,255,0.4)',
};

const lightPluginCard = {
  'plugin.bg.color': '#FFFFFF',
  'plugin.header.color': 'rgba(0,0,0,0.7)',
  'plugin.description.color': 'rgba(0,0,0,0.6)',
  'plugin.version.color': 'rgba(0,0,0,0.4)',
};

const darkPluginCard = {
  'plugin.bg.color': '#263142',
  'plugin.header.color': 'rgba(255,255,255,0.7)',
  'plugin.description.color': 'rgba(255,255,255,0.6)',
  'plugin.version.color': 'rgba(255,255,255,0.4)',
};

const themes = {
  light: {
    ...lightModal,
    ...lightPluginCategoriesSidebar,
    ...lightPluginCard,
  },
  dark: {
    ...darkModal,
    ...darkPluginCategoriesSidebar,
    ...darkPluginCard,
  },
};

export default themes;
